export default {
  apiDomain: '127.0.0.1:5001',
  payPalClientId: 'AZTFoCJUBouxkynuKgSapwxt4ZX3SYiEwSncvc4eA9s_f95YQwV6awypMBpk3Ys4S6323rNA5MAVL3Xz',
  mixpanelToken: '',
  // includedServices: [],

  locationsFileUrl: 'https://github.com/outscraper/postal-codes-json-xml-csv/tree/master/data',
  fileUploaderDir: 'uploads',
  hcaptchaSiteKey: '10000000-ffff-ffff-ffff-000000000001',
  taskExpiredAfter: 45,
  taskExpiredAfterSoft: 30,
  queriesSoftLimit: 70000,
  queriesHardLimit: 150000,
};
